<template>
  <div class="view pa24">

    <el-dialog
        :title="title"
        width="800px"
        :modal-append-to-body="false"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :before-close="closeDialog"
    >
      <el-form
          :model="ruleForm"
          :rules="rules"
          ref="dealerRuleForm"
          label-width="110px"
          class="ruleForm"
      >
        <el-form-item label="名称" prop="name">
          <el-input v-model="ruleForm.name"></el-input>
        </el-form-item>
        <el-form-item label="所属父级" v-if="!isHzp">
          <el-select class="main-select-tree" ref="selectTree" clearable @clear="setValueNull"
                     v-model="parentName" style="width: 100%;" name='option 1'>
            <el-option v-for="item in optionData(classList)" :label="item.label" :value="item.id" :key="item.label"
                       style="display: none;" />

            <el-tree class="main-select-el-tree" ref="selectelTree" :data="classList" :props='treeProps'
                     highlight-current @node-click="handleNodeClick" :expand-on-click-node="expandOnClickNode"/>
          </el-select>
        </el-form-item>
        <el-form-item label="备案信息" v-if="isHzp" prop="filingId">
          <el-select v-model="ruleForm.filingId" placeholder="请选择">
            <el-option
                v-for="item in filings"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商家名称" v-if="!isHzp">
          <el-input v-model="ruleForm.busName"></el-input>
        </el-form-item>
        <el-form-item label="货品编码">
          <el-input v-model="ruleForm.goodsCode"></el-input>
        </el-form-item>
        <el-form-item label="规格码" v-if="!isHzp">
          <el-input v-model="ruleForm.specCode"></el-input>
        </el-form-item>
        <el-form-item label="规格名称" v-if="!isHzp">
          <el-input v-model="ruleForm.specName"></el-input>
        </el-form-item>
        <el-form-item label="产品执行标准" v-if="isHzp" prop="standard">
          <el-input v-model="ruleForm.standard"></el-input>
        </el-form-item>
        <el-form-item label="成分" v-if="isHzp" prop="ingredient">
          <el-input v-model="ruleForm.ingredient" type="textarea"></el-input>
        </el-form-item>
        <el-form-item label="微量成分" v-if="isHzp" prop="traceIngredient">
          <el-input v-model="ruleForm.traceIngredient" type="textarea"></el-input>
          <p style="font-size: 12px;color: red;">配方中存在含量不超过0.1%（w/w）成分时为必填</p>
        </el-form-item>
        <el-form-item label="净含量" v-if="isHzp" prop="netContent">
          <el-input v-model="ruleForm.netContent"></el-input>
        </el-form-item>
        <el-form-item label="使用方法" v-if="isHzp">
          <el-input v-model="ruleForm.useInfo" type="textarea"></el-input>
        </el-form-item>
        <el-form-item label="产品名称相关解释说明" v-if="isHzp">
          <el-input v-model="ruleForm.productionExplanation" type="textarea"></el-input>
        </el-form-item>
        <el-form-item label="注意/警告" v-if="isHzp">
          <el-input v-model="ruleForm.attention" type="textarea"></el-input>
        </el-form-item>
        <el-form-item label="创新用语" v-if="isHzp">
          <el-input v-model="ruleForm.innovation" type="textarea"></el-input>
        </el-form-item>
        <el-form-item label="下限数量" v-if="!isHzp">
          <el-input-number :min="0" v-model="ruleForm.minNum"></el-input-number>
        </el-form-item>
        <el-form-item label="排序">
          <el-input type="number" v-model="ruleForm.sort"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button class="btncss" @click="confirmAddCustomer" :loading="submitLoading">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {addPageClass, pageClassList} from '@/api/customPageClass.js'
import {selectAllCategory} from "@/api/productCategory";
import {selectFilings} from "../../../api/hzpFilingInfo";

export default {
  name: "addPageClass",
  components: {
    // BaiduMap,
  },
  props: [],

  data() {
    return {
      //测试
      provinces: [],
      classType: null,
      dialogVisible: false,
      title: '添加类别',

      parentId: '',
      parentName: '',
      treeProps: {
        children: 'children',
        label: 'name'
      },
      expandOnClickNode: false,
      ruleForm: {
        name: '',
        sort: 999,
        parentId: null,
        busName: '',
        goodsCode: '',
        specCode: '',
        specName: '',
        minNum: 0,
        standard: '',
        ingredient: '',
        traceIngredient: '',
        netContent: '',
        useInfo: '',
        productionExplanation: '',
        innovation: '',
        attention: '',
        filingId:''
      },
      rules: {
        filingId: [
          {required: true, message: '请选择备案信息', trigger: 'blur'},
        ],
        name: [
          {required: true, message: '请输入类别名称', trigger: 'blur'},
        ],
        busName: [
          {required: true, message: '请输入商家名称', trigger: 'blur'},
        ],
        goodsCode: [
          {required: true, message: '请输入货品编码', trigger: 'blur'},
        ],
        specCode: [
          {required: true, message: '请输入规格码', trigger: 'blur'},
        ],
        specName: [
          {required: true, message: '请输入规格名称', trigger: 'blur'},
        ],
        standard: [
          {required: true, message: '请输入产品执行标准', trigger: 'blur'},
        ],
        ingredient: [
            {required: true, message: '请输入成分', trigger: 'blur'},
        ],
        netContent: [
            {required: true, message: '请输入净含量', trigger: 'blur'},
        ]
      },
      type: 'add',
      id: '',
      classList: [{value: 0, label: 'fadsfs'}],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      isHzp:false,
      filings: [],
      submitLoading:false
    };
  },
  onShow() {
  },
  methods: {
    onSelect(node, instanceId) {
      if (node.hasChildren && node.children && node.children.length > 0) {
        this.$message.error("请选择子级节点")
        this.ruleForm.categoryId = ''
        return false; // 阻止选择非叶子节点
      }
      // 如果需要，可以在这里处理叶子节点的选择逻辑
    },
    loadMenus({ action, parentNode, callback }) {
      if (action === LOAD_CHILDREN_OPTIONS) {
        if (parentNode.children){
          parentNode.children = parentNode.children.map(function(obj) {
            obj.leaf = false
            return obj
          })
        }else {
          parentNode.children = ''
        }
        setTimeout(() => {
          callback()
        }, 100)
      }
    },
    handleCheckChange(node, list) {
      this.ruleForm.parentId = node.id;
      //选中事件在选中后执行，当lis中有两个选中时，使用setCheckedKeys方法，选中一个节点
      if (list.checkedKeys.length == 2) {
        //单选实现
        this.$refs.selectTree.setCheckedKeys([node.id]);
      }
    },
    getAllClass() {
      selectAllCategory().then(res => {
        this.classList = res.data
      })
    },
    openDialog(type, data, classType,isHzp) {
      if (isHzp){
        this.isHzp = isHzp
        this.getFilings()
      }
      this.getAllClass()
      this.dialogVisible = true
      let v = this
      v.classType = classType
      if (type === 'add') {
        this.title = '添加产品'
        this.type = 'add'
        this.id = ''
        this.$nextTick(() => {
          this.$refs.dealerRuleForm.clearValidate();
          this.$refs.dealerRuleForm.resetFields();
        })
        this.ruleForm.name = ''
        this.ruleForm.minNum = 0
        this.ruleForm.goodsCode = ''
        this.ruleForm.specCode = ''
        this.ruleForm.specName = ''
        this.ruleForm.busName = ''
        this.ruleForm.standard = ''
        this.ruleForm.ingredient = ''
        this.ruleForm.traceIngredient = ''
        this.ruleForm.netContent = ''
        this.ruleForm.useInfo = ''
        this.ruleForm.productionExplanation = ''
        this.ruleForm.innovation = ''
        this.attention= ''
        this.filingId = ''
      } else {
        this.title = '编辑类别'
        this.getData(data)
        this.type = "edit"
        this.id = data.id
      }
    },
    handleNodeClick(node) {
      if (node.hasChildren && node.children){
        this.$message.error("请选择子级节点")
        this.ruleForm.categoryId = ''
        return false;
      }
      this.ruleForm.categoryId = node.id
      this.parentName = node.fullName
      this.$refs.selectTree.blur();
    },
    setValueNull() {
      this.ruleForm.parentId = '';
      this.parentName = ''
    },
    optionData(array, result = []) {
      array.forEach(item => {
        result.push({
          label: item.fullName,
          value: item.id
        })
        if (item.children && item.children.length !== 0) {
          this.optionData(item.children, result)
        }
      })
      return JSON.parse(JSON.stringify(result))
    },
    closeDialog() {
      this.dialogVisible = false
      this.resetForm()
      this.$emit('getList')
    },
    resetForm() {
      this.$refs.dealerRuleForm.resetFields();
    },
    confirmAddCustomer() {
      this.$refs.dealerRuleForm.validate((valid) => {
        if (valid) {
          this.submitLoading = true
          let params = {
            name: this.ruleForm.name,
            sort: this.ruleForm.sort,
            type: this.classType,
            parentId: this.ruleForm.parentId,
            busName: this.ruleForm.busName,
            goodsCode: this.ruleForm.goodsCode,
            specCode: this.ruleForm.specCode,
            specName: this.ruleForm.specName,
            minNum: this.ruleForm.minNum,
            categoryId: this.ruleForm.categoryId,
            standard: this.ruleForm.standard,
            ingredient: this.ruleForm.ingredient,
            traceIngredient: this.ruleForm.traceIngredient,
            netContent: this.ruleForm.netContent,
            useInfo: this.ruleForm.useInfo,
            productionExplanation: this.ruleForm.productionExplanation,
            innovation: this.ruleForm.innovation,
            attention: this.ruleForm.attention,
            isHzp:this.isHzp,
            filingId:this.ruleForm.filingId
          }
          if (this.type === 'edit') {
            params.id = this.id
            addPageClass(params).then(res => {
              if (res.code === 200) {
                this.$message({
                  type: "success",
                  message: "操作成功",
                });
                this.submitLoading = false
                this.closeDialog()
              }
            }).catch(error => {
              this.submitLoading = false
            })
          } else {
            addPageClass(params).then(res => {
              if (res.code === 200) {
                this.$message({
                  type: "success",
                  message: "操作成功",
                });
                this.submitLoading = false
                this.closeDialog()
              }
            }).catch(error => {
              this.submitLoading = false
            })
          }

        }
      })
    },
    // 回显
    getData(data) {
      this.ruleForm.name = data.name
      this.ruleForm.sort = data.sort
      this.ruleForm.parentId = data.parentId
      this.ruleForm.busName = data.busName
      this.ruleForm.goodsCode = data.goodsCode
      this.ruleForm.specCode = data.specCode
      this.ruleForm.specName = data.specName
      this.ruleForm.minNum = data.minNum
      this.parentName = data.categoryName
      this.ruleForm.categoryId = data.categoryId
      this.ruleForm.standard = data.standard
      this.ruleForm.ingredient = data.ingredient
      this.ruleForm.traceIngredient = data.traceIngredient
      this.ruleForm.netContent = data.netContent
      this.ruleForm.useInfo = data.useInfo
      this.ruleForm.productionExplanation = data.productionExplanation
      this.ruleForm.innovation = data.innovation
      this.ruleForm.attention = data.attention
      this.ruleForm.filingId = data.filingId
    },
    getFilings(){
      selectFilings().then(res=>{
        this.filings = res.data
      })
    }
  },


};
</script>

<style lang="scss" scoped>
.ml10 {
  margin-left: 10rpx;
}

/* 隐藏没有子节点的箭头 */
.vue-treeselect__menu-item-container--no-children .vue-treeselect__arrow {
  display: none;
}
</style>
